import React, {HTMLElementType, ReactElement} from 'react';
import {Box, Typography, IconButton} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ArrTooltipWrapper from '../arr-tooltip-wrapper/ArrTooltipWrapper';
import './ArrTooltipTitle.scss';

// Types Definitions
// ----------------------------------
interface ArrTooltipTitleProps {
  classNames?: {
    wrapper?: string;
    title?: string;
    tooltipIcon?: string;
  };
  title: string;
  titleElement?: HTMLElementType;
  tooltipTitle?: string;
  tooltipContent?: string | ReactElement;
  dataTestId: string;
}

// ----------------------------------
// ArrTooltipTitle Component
// ----------------------------------
const ArrTooltipTitle: React.FC<ArrTooltipTitleProps> = ({
  classNames = {},
  title,
  titleElement = 'span',
  tooltipTitle = '',
  tooltipContent = '',
  dataTestId = 'title',
}) => {
  return (
    <Box className={`arr-tooltip-title ${classNames.wrapper}`}>
      <Typography
        component={titleElement}
        className={classNames.title}
        data-testid={`arr-tooltip-title-${dataTestId}`}
      >
        {title}
      </Typography>
      <ArrTooltipWrapper
        title={tooltipTitle}
        data-testid="arr-tooltip-title-wrapper"
        trigger={
          <IconButton
            aria-label="Info"
            className="tooltip-button"
            data-testid={`arr-tooltip-title-button-${dataTestId}`}
          >
            <InfoOutlinedIcon
              className={`tooltip-icon ${classNames.tooltipIcon}`}
              fontSize="inherit"
              data-testid={`arr-tooltip-title-icon-${dataTestId}`}
            />
          </IconButton>
        }
      >
        {tooltipContent}
      </ArrTooltipWrapper>
    </Box>
  );
};

export {ArrTooltipTitle};
export default ArrTooltipTitle;
